import { render } from "./ArrowRight.vue?vue&type=template&id=44ae4c37&scoped=true"
import script from "./ArrowRight.vue?vue&type=script&lang=js"
export * from "./ArrowRight.vue?vue&type=script&lang=js"

import "./ArrowRight.vue?vue&type=style&index=0&id=44ae4c37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ae4c37"]])

export default __exports__